<template lang="pug">
  SspLayout.validation-simulator(area="core")
    .row
      .col-sm-6
        form.panel.panel-default(role="form" @submit.prevent="simulateValidation")
          .panel-heading.panel-title Code Validation
          .panel-body
            .form-horizontal
              .form-group
                label.col-sm-4 Channel
                .col-sm-8
                  EntrychannelSelect(v-model="entryChannelId")

              .form-group(v-if="entryChannelType")
                div(v-if="entryChannelType  === 'sms'")
                  label.col-sm-4 Country
                  .col-sm-8
                    CountrySelect(v-model="country" :placeholder="`Optional Country Select`")
                div(v-if="entryChannelType  === 'web'")
                  label.col-sm-4 Ip Address
                  .col-sm-8
                    IpAddressControl(placeholder="Optional Ip Address" v-model="ipAddress")

              .form-group
                label.col-sm-4 Validation Count
                .col-sm-8
                  input.form-control(type="number" v-model="validationCount")

              .form-group
                label.col-sm-4 Date
                .col-sm-8
                  Datepicker(v-model="timestamp" placeholder="Optional Time of Validation" :timePicker="true")

              .form-group
                label.col-sm-4 Code
                .col-sm-8
                  input.form-control(type="text" v-model="code")
              .form-group
                .col-sm-4
                .col-sm-8
                  p.mismatch-warning {{codeConfigMismatch}}

          .panel-footer
            .text-right
              SspActionButton(type="submit" :disabled="!isValid" text="Simulate" :spinning="simulating")


      .col-sm-6
        .panel.panel-default
          .panel-heading.panel-title Validation Result
          .panel-body
            p(v-html="validationResult")
</template>

<script>
import Core from '@/service/apis/Core'
import EntrychannelSelect from '@/components/ssp/EntrychannelSelect'
import CountrySelect from '@/components/ssp/CountrySelect'
import IpAddressControl from '@/components/common/IpAddressControl'
import Datepicker from '@/components/common/Datepicker'
import Util from '@/service/Util'

export default {
  data: () => ({
    simulating: false,
    entryChannelId: null,
    selectedEntryChannel: null,
    entryChannelType: null,
    country: null,
    ipAddress: null,
    validationCount: null,
    code: null,
    validationResult: null,
    timestamp: null
  }),
  methods: {
    simulateValidation() {
      this.simulating = true
      const code = Util.sanitizeCode(this.code)

      const req = {
        channelId: this.entryChannelId,
        validationNo: this.validationCount,
        code,
        country: this.country ? this.country.code : null,
        ip: this.ipAddress,
        date: this.timestamp
      }

      Core.simulateValidation(req)
        .then((resp) => {
          this.validationResult = resp.data
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.simulating = false
        })
    }
  },
  watch: {
    entryChannelId() {
      if (this.entryChannelId) {
        Core.getEntryChannel(this.entryChannelId)
          .then((resp) => {
            this.selectedEntryChannel = resp.data.webEntryChannel || resp.data.smsEntryChannel
            if (resp.data.webEntryChannel) {
              this.entryChannelType = 'web'
            }
            if (!resp.data.webEntryChannel) {
              this.entryChannelType = 'sms'
            }
          })
      } else {
        this.entryChannelType = null
        this.selectedEntryChannel = null
      }
    }
  },
  computed: {
    isValid() {
      return this.entryChannelId && this.validationCount && this.code
    },
    codeConfigMismatch() {
      if (this.selectedEntryChannel && this.selectedEntryChannel.codeConfig && this.code && this.code.includes(':')) {
        const code = this.code.split(':')
        if (parseInt(code[2], 10) !== this.selectedEntryChannel.codeConfig.id) {
          return 'This code does not belong to this channel'
        }
      }
      return null
    }
  },
  components: {
    EntrychannelSelect,
    CountrySelect,
    IpAddressControl,
    Datepicker
  }
}
</script>

<style lang="scss">
.validation-simulator {
  .mismatch-warning {
    font-weight: bold;
    color: #fd7e14;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/validation/ValidationSimulator.vue